export enum ActionType {
  CHANGE_SAMPLE_VALUE = 'CHANGE_SAMPLE_VALUE',
}

export type AppAction = { type: ActionType.CHANGE_SAMPLE_VALUE; payload: string };
